import { useRouter } from 'next/router';
import { useMemo } from 'react';
type ParsedParams = {
  reservationPublicId: number;
  mulpaySaveAsLastUsed: boolean;
};

type Result = ParsedParams | undefined;

/**
 * GMO-PGのコールバックパラメータをrouterから取得し、予約IDと支払い方法保存フラグを取得する
 * ReservationFlowにおいては、イベント予約、コース予約ともに特定のpathと特定のqueryが3DS認証後のcallbackで設定される前提のため、共通化している
 */
export const useParsedMulpayCallbackParams = (): Result => {
  const router = useRouter();

  const { p, reservationPublicId, saveAsLastUsed } = router.query;

  // callback用のクエリはstring以外は不正なので受け取らない
  const mulpayCallbackParams = typeof p === 'string' ? p : undefined;
  const reservationPublicIdParams =
    typeof reservationPublicId === 'string' ? reservationPublicId : undefined;
  // 0か1の値がクエリパラメーターにserverから設定される
  const saveAsLastUsedParams =
    typeof saveAsLastUsed === 'string' ? saveAsLastUsed : undefined;

  const extractedMulpayCallbackParams = useMemo<
    ParsedParams | undefined
  >(() => {
    if (
      mulpayCallbackParams &&
      reservationPublicIdParams &&
      saveAsLastUsedParams
    ) {
      const reservationPublicId = parseInt(reservationPublicIdParams, 10);
      const mulpaySaveAsLastUsed = parseInt(saveAsLastUsedParams, 10);

      if (isNaN(reservationPublicId) || isNaN(mulpaySaveAsLastUsed)) {
        return;
      }

      return {
        reservationPublicId,
        mulpaySaveAsLastUsed: Boolean(mulpaySaveAsLastUsed),
      };
    } else {
      return;
    }
  }, [mulpayCallbackParams, reservationPublicIdParams, saveAsLastUsedParams]);

  return extractedMulpayCallbackParams;
};
